//External Libraries
import { useTranslation } from 'react-i18next';

//Components
import { CMTooltip } from '@chartmetric/chartmetric-design-system/components/CMTooltip';

//Utils
import { PLAN_COLOR_VARS } from '../utils';

//Types
import type { AnnouncementPlan } from '../types';

interface Props {
  plan: AnnouncementPlan;
}

function AnnouncementPlanTag({ plan }: Props) {
  const { t } = useTranslation('common', { keyPrefix: 'announcementPanel' });
  const colorVar = PLAN_COLOR_VARS[plan];
  const planName = t(`plans.${plan}`);

  return (
    <CMTooltip>
      <CMTooltip.Trigger>
        <span
          className="inline-block text-xs font-medium px-2.5 py-0.5 rounded-xs border border-solid leading-relaxed tracking-wide cursor-default"
          style={{
            color: colorVar,
            borderColor: colorVar,
            backgroundColor: `color-mix(in srgb, ${colorVar} 12%, transparent)`,
          }}
        >
          {planName}
        </span>
      </CMTooltip.Trigger>
      <CMTooltip.Content zIndex={1100}>
        {t('planTooltip', { plan: planName })}
      </CMTooltip.Content>
    </CMTooltip>
  );
}

export default AnnouncementPlanTag;
